import { Role } from "@/lib/constants/roles";

/**
 * Read-only view gate. Mirrors the backend `IsSystemAdminOrDistributorAdmin` on
 * the analytics endpoints: system admins, platform managers (covered by
 * `is_platform_admin`), and distributors. MSP admins get 403 there.
 */
export interface MspCredentialsCapabilities {
  canView: boolean;
}

const NONE: MspCredentialsCapabilities = { canView: false };

const VIEWER_ROLES: readonly string[] = [
  Role.PLATFORM_ADMIN,
  Role.PLATFORM_MANAGER,
  Role.DISTRIBUTOR_ADMIN,
];

export function mspCredentialsCapabilities(
  role: string | undefined,
): MspCredentialsCapabilities {
  if (role == null) return NONE;
  return VIEWER_ROLES.includes(role) ? { canView: true } : NONE;
}
